<footer class="footer">
  <div class="footer__content">
    <span>© {{ currentYear }} PaScal Viewer. All rights reserved.</span>
  </div>
</footer>